import { useEffect, useState } from "react";
import { fetchUsagers } from "../api/api";

export default function UsagerList() {
    const [usagers, setUsagers] = useState([]);

    useEffect(() => {
        fetchUsagers().then(setUsagers);
    }, []);

    return (
        <div>
            <h2 className="text-xl font-bold">Liste des Usagers</h2>
            <ul>
                {usagers.map((usager) => (
                    <li key={usager.id_usager}>{usager.nom} {usager.prenom} - {usager.email}</li>
                ))}
            </ul>
        </div>
    );
}
